import { COUNTRY } from "./app"

export const SITE_URL = {
    [COUNTRY.AUS]: 'https://dev-spa.nonprod.readingcinemas.com.au',
    [COUNTRY.NZ]: 'https://dev-spa.nonprod.readingcinemas.co.nz',
    [COUNTRY.ANG]: 'https://dev-spa.nonprod.angelikacinemas.com.au',
    [COUNTRY.STA]: 'https://dev-spa.nonprod.statecinema.com.au',
    [COUNTRY.US]: 'https://readingcinemas.com',
    [COUNTRY.CON]: 'https://consolidatedtheatres.com',
    [COUNTRY.AFC]: 'https://angelikafilmcenter.com',
}

export const META_DESC:any = {
    [COUNTRY.AUS]: {
        nowshowing: {
            title: 'Now Showing',
            description: 'See what’s playing on the big screen near you.'
        },
        comingSoon: {
            title: 'Coming Soon ',
            description: 'Browse upcoming blockbuster releases.'
        },
        rewards: {
            title: 'Reading Rewards',
            description: 'Learn more about our exciting Rewards program.'
        },
        cinemas: {
            title: 'Find A Cinema',
            description: 'Explore our locations across Australia.'
        },
        giftshop: {
            title: 'Gift Ideas ',
            description: 'Give the gift of movies with a Reading Cinemas Gift Card.'
        }
    },
    [COUNTRY.NZ]: {
        nowshowing: {
            title: 'Now Showing',
            description: 'See what’s playing on the big screen near you.'
        },
        comingSoon: {
            title: 'Coming Soon ',
            description: 'Browse upcoming blockbuster releases.'
        },
        rewards: {
            title: 'Reading Rewards',
            description: 'Learn more about our exciting Rewards program.'
        },
        cinemas: {
            title: 'Find A Cinema',
            description: 'Explore our locations across Australia.'
        },
        giftshop: {
            title: 'Gift Ideas ',
            description: 'Give the gift of movies with a Reading Cinemas Gift Card.'
        }
    },
    [COUNTRY.ANG]: {
        nowshowing: {
            title: 'Now Showing',
            description: 'See what’s playing at Angelika Cinemas today.'
        },
        comingSoon: {
            title: 'Coming Soon ',
            description: 'Browse upcoming Blockbuster and Arthouse releases.'
        },
        rewards: {
            title: 'Angelika Rewards',
            description: 'Learn more about our exciting Rewards program.'
        },
        specialEvents: {
            title: 'Special Events',
            description: 'Discover special events at Angelika Cinemas.'
        },
        giftshop: {
            title: 'Gift Ideas ',
            description: 'Give the gift of movies with an Angelika Cinemas Gift Card.'
        }
    },
    [COUNTRY.STA]: {
        nowshowing: {
            title: 'Now Showing',
            description: 'See what’s playing at the State Cinema today.'
        },
        COMING_SOON: {
            title: 'Coming Soon ',
            description: 'Browse upcoming releases from around the world.'
        },
        REWARDS: {
            title: 'Angelika Rewards',
            description: 'Learn more about our exciting Rewards program.'
        },
        SPECIAL_EVENTS: {
            title: 'Special Events',
            description: 'Discover special events at The State Cinema.'
        },
        GIFTSHOP: {
            title: 'Gift Ideas ',
            description: 'Give the gift of movies with a State Cinema Gift Card.'
        }
    }
}








